import { AppProps } from "next/app";
import path from "path";

import { ErrorBoundary, ErrorScreen } from "@tm/ui/ui-container";

import "./styles.css";

// Magic import
path.resolve("./next.config.js");

function CustomApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <main className="app">
        <ErrorBoundary onError={(error) => <ErrorScreen error={error} />}>
          <Component {...pageProps} />
        </ErrorBoundary>
      </main>
    </>
  );
}

export default CustomApp;
